// Professional facts transcribed from the documents supplied by the cabinet.
// Source documents are deliberately not linked or embedded in the public site.
export const PROFESSIONAL = {
  orias: '24005994',
  oriasWebsite: 'https://www.orias.fr',
  category: 'Courtier d’assurance ou de réassurance (COA)',
  registrationDate: '30 août 2024',
  registrationAttestationDate: '3 février 2026',
  registrationEndDate: '28 février 2027',
  liability: {
    insurer: 'LIBERTY MUTUAL INSURANCE EUROPE SE',
    policy: 'RCGLS002654',
    namedInsured: 'Djibril Wagué',
    startsAt: '15 janvier 2026 à 0 h 00',
    endsAt: '28 février 2027 à 0 h 00',
  },
};